var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 pt-1 mx-auto"},[_c('div',{staticClass:"h3 gilmer text-azul-oscuro text-uppercase mt-2 px-3 px-lg- font-weight-light text-center"},[_vm._v("\n    "+_vm._s(_vm.texto)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c7cc036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-carousel-slide":"img-src"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generales/Titulo.vue
// module id = XJtT
// module chunks = 1